import React from 'react';
import { FaClock, FaCheckCircle, FaTimesCircle, FaMapMarkerAlt } from 'react-icons/fa';
import { SavedLocation } from '../types/locationState';

interface StatusDisplayProps {
  isCheckedIn: boolean;
  isWithinRadius: boolean;
  checkInTime: Date | null;
  lastAction: string;
  savedLocation: SavedLocation | null;
  onTimeAction: (action: 'in' | 'out') => void;
}

const StatusDisplay: React.FC<StatusDisplayProps> = ({
  isCheckedIn,
  isWithinRadius,
  checkInTime,
  lastAction,
  savedLocation,
  onTimeAction
}) => {
  return (
    <div className="status-section">
      {savedLocation ? (
        <>
          <p><FaMapMarkerAlt className="inline-icon" /> Selected Location: <span className="status-text">{savedLocation.name}</span></p>
          <p>Status: <span className={`status-text ${isCheckedIn ? 'checked-in' : ''}`}>
            {isCheckedIn ? (
              <><FaCheckCircle className="inline-icon checked-in-icon" /> Currently Timed In</>
            ) : (
              <><FaClock className="inline-icon" /> Not Timed In</>
            )}
          </span></p>
          <p>Location: <span className={`status-text ${isWithinRadius ? 'in-range' : 'out-of-range'}`}>
            {isWithinRadius ? (
              <><FaCheckCircle className="inline-icon in-range-icon" /> Within work area</>
            ) : (
              <><FaTimesCircle className="inline-icon out-of-range-icon" /> Outside work area</>
            )}
          </span></p>
          {isCheckedIn && checkInTime && (
            <p>Time In Duration: <span className="status-text">
              {Math.round((new Date().getTime() - checkInTime.getTime()) / (1000 * 60))} minutes
            </span></p>
          )}
          <p>Last Action: <span className="action-text">{lastAction}</span></p>

          <div className="button-group">
            <button 
              type="button" 
              className="time-btn"
              onClick={() => onTimeAction('in')}
              disabled={!isWithinRadius || isCheckedIn}
            >
              Time In
            </button>
            <button 
              type="button" 
              className="time-btn"
              onClick={() => onTimeAction('out')}
              disabled={!isWithinRadius || !isCheckedIn}
            >
              Time Out
            </button>
          </div>
        </>
      ) : (
        <p>Select a location or add a new one to start timing in/out.</p>
      )}
    </div>
  );
};

export default StatusDisplay;
